//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import * as merchant from '@/api/merchant';
import product from '@/mixins/product';
export default {
  name: 'index',
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    merIdChecked: {
      type: [Array, String, Number],
      default: function _default() {
        return null;
      }
    }
  },
  watch: {
    merIdChecked: function merIdChecked(n) {
      this.merIds = n;
    }
  },
  data: function data() {
    return {
      merProps: {
        value: 'id',
        label: 'name',
        children: 'merchantList',
        expandTrigger: 'hover',
        emitPath: false,
        multiple: this.multiple
      },
      merSelect: [],
      merIds: null
    };
  },
  mounted: function mounted() {
    this.merIds = this.merIdChecked;
    this.getMerList();
  },
  methods: {
    // 列表
    getMerList: function getMerList() {
      var _this = this;
      merchant.merCategoryListApi().then(function (res) {
        _this.merSelect = res;
      });
    },
    onChangeMerId: function onChangeMerId() {
      this.$emit('getMerId', this.merIds);
    }
  }
};